import React, { useEffect, useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import TextContainerField from "../../../components/TextContainerField";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById } from "../../../api/Services";
import Spinner from "../../../components/Spinner";


const ViewGeneralDiscount = () => {
  const navigate = useNavigate();
  const params = useParams();
  const paramId = params.id;
  const [isLoading, setIsLoading] = useState(false);
  const [discountData, setDiscountData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {

      if (paramId) {
        setIsLoading(true);
        try {
          await fetchDataById(`/reference/general/discount/${paramId}`).then((res) => {
            setDiscountData((prevData) => ({
              ...prevData,
              ...res.data?.discount,
            }));
          });
        } catch (err) {
          console.log(err);
        } finally {
            setIsLoading(false);
        }
      }
    };

    fetchData();
  }, [paramId]);

  if (isLoading) {
    return (
      <DashboardLayout>
        <Spinner />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
        <Box
          sx={{
            padding: { xs: 2, md: 2 },
            bgcolor: "#f9f9f9",
            minHeight: "75vh",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="left"
            spacing={1}
            mb={2}
          >
            <IconButton
              onClick={() => navigate("/general-master/general-discount")}
            >
              <ArrowBack />
            </IconButton>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
              General Discount Information
            </Typography>
          </Stack>

          {discountData ? (
          <Grid container spacing={3} sx={{ mx: { xs: 0, md: 2 } }}>
            <Grid xs={12} sm={6} md={4} sx={{ width: "100%" }}>
              <Card sx={{ boxShadow: 3, borderRadius: 2, bgcolor: "white" }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: "600" }}>
                    {discountData?.name}
                  </Typography>
                  <TextContainerField label="IPL Discount ID" value={discountData?.id} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Max Limit" value={discountData?.maxLimit} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Description" value={discountData?.description} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Product" value={discountData?.product?.keyName} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Policy Type" value={discountData?.policyType?.keyName} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Auto Apply" value={discountData?.autoApply ? "Yes" : "No"} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Mandatory" value={discountData?.mandatory ? "Yes" : "No"} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Status" value={discountData?.isActive ? "Active" : "Inactive"} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Created By" value={discountData?.createdBy} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Created At" value={discountData?.createdAt} labelStyle={{ fontWeight: "500" }} />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          ) : (
            <Box>
              <Typography variant="h4" gutterBottom sx={{ textAlign: "center", fontWeight: "bold", color: "red", fontFamily: "cursive" }}>
                No Discount Data Found
              </Typography>
            </Box>
          )}
        </Box>
    </DashboardLayout>
  );
};

export default ViewGeneralDiscount;
